@if (chartId) {
  <div class="container common-container-padding">
    <div class="grouped-chart-title">GWP by class by year</div>
    <div class="grouped-chart-container">
      <canvas [id]="chartId" class="canvas-styles"></canvas>
    </div>
    <div class="bottom-text labelFont">
      <div
        [innerText]="desktopView ? year1Desktop : year1Mobile"
        class="first-label"
      ></div>
      <div
        [innerText]="desktopView ? year2Desktop : year2Mobile"
        class="second-label"
      ></div>
    </div>
  </div>
}
